import MantDiasTraslado from './MantDiasTraslado';

export default {
  route: {
    path: '/mantenimiento-dias-traslado',
    component: MantDiasTraslado,
  },
};



// WEBPACK FOOTER //
// ./src/pages/MantDiasTraslado/index.js